import { useState } from "react";
import { Link } from "react-router-dom";
import { Crown } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const PLAN_NAMES = { premium_monthly: "Mensuel · 5,99 € TTC/mois", premium_yearly: "Annuel · 49 € TTC/an" };

export default function Subscription() {
  const { user, refreshUser } = useAuth();
  const [busy, setBusy] = useState(false);
  const date = user.premium_until && new Date(user.premium_until).toLocaleDateString("fr-FR");

  const cancel = async () => {
    if (!window.confirm("Annuler l'abonnement ? Premium restera actif jusqu'à la fin de la période payée.")) return;
    setBusy(true);
    try {
      await api.post("/payments/cancel");
      await refreshUser();
      toast.success("Abonnement annulé. Premium reste actif jusqu'à la fin de la période.");
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="subscription-box" className="card-paper mt-5 p-5">
      <div className="flex items-center gap-2 font-display text-xl font-bold"><Crown size={20} className="text-[color:var(--sun)]" /> Abonnement</div>
      {user.is_premium ? (
        <>
          <p data-testid="subscription-status" className="mt-2 font-semibold">Premium {PLAN_NAMES[user.plan] ? `· ${PLAN_NAMES[user.plan]}` : ""}</p>
          <p className="text-sm text-[color:var(--muted-ink)]">
            {user.cancel_at_period_end ? `Annulé : l'accès se termine le ${date}, plus aucun prélèvement`
              : user.in_trial ? `Essai gratuit jusqu'au ${date}, puis prélèvement automatique de ${user.plan === "premium_yearly" ? "49 € TTC par an" : "5,99 € TTC par mois"} sauf annulation`
              : `Actif jusqu'au ${date}, renouvelé automatiquement`}
          </p>
          <p className="mt-1 text-sm text-[color:var(--muted-ink)]">{user.ai_stories_left} histoires IA restantes ce mois-ci</p>
          {!user.cancel_at_period_end && user.role !== "admin" && (
            <button data-testid="subscription-cancel-button" disabled={busy} onClick={cancel} className="mt-3 text-sm font-bold text-[color:var(--terracotta)] underline">Annuler l'abonnement</button>
          )}
        </>
      ) : (
        <>
          <p data-testid="subscription-status" className="mt-2 text-[color:var(--muted-ink)]">Formule gratuite : 2 histoires, quiz et vocabulaire.</p>
          <Link to="/premium" data-testid="subscription-upgrade-button" className="btn-primary mt-4 !py-2 !text-base">Passer à Premium</Link>
        </>
      )}
    </div>
  );
}
